var exports = {
  "kL": "xe564cbfb--dab2ea--container",
  "nf": "xe564cbfb--dab2ea--link",
  "d4": "xe564cbfb--dab2ea--star",
};

module.exports = exports;
